import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=4c58a84e&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=4c58a84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58a84e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c58a84e')) {
      api.createRecord('4c58a84e', component.options)
    } else {
      api.reload('4c58a84e', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=4c58a84e&scoped=true&", function () {
      api.rerender('4c58a84e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/authority/components/addDynamic.vue"
export default component.exports